import React from "react";
import { C, mono, font } from "../config/theme";

/**
 * MiniTable — Tableau récapitulatif compact avec ligne de totaux
 *
 * Props :
 *   - title   : titre affiché en haut (uppercase)
 *   - color   : couleur d'accent du titre
 *   - headers : [{key, label, align?, mono?, bold?, maxW?, render?, total?}]
 *               render(row, index) → valeur cellule
 *               total(rows) → valeur pied de colonne
 *   - rows    : données (tableau d'objets)
 */
export default function MiniTable({ title, color, headers, rows }) {
  return (
    <div
      style={{
        background: C.surface,
        borderRadius: 14,
        border: `1px solid ${C.border}`,
        padding: "16px 20px",
        boxShadow: "0 1px 8px rgba(0,0,0,0.05)",
      }}
    >
      {/* Titre */}
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          color,
          marginBottom: 12,
        }}
      >
        {title}
      </div>

      {/* Tableau */}
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
          fontSize: 11,
          fontFamily: font,
        }}
      >
        <thead>
          <tr>
            {headers.map((h, i) => (
              <th
                key={i}
                style={{
                  textAlign: h.align || "left",
                  padding: "6px 8px",
                  fontSize: 10,
                  fontWeight: 600,
                  color: C.slate,
                  borderBottom: `1.5px solid ${C.border}`,
                  whiteSpace: "nowrap",
                }}
              >
                {h.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} style={{ background: i % 2 === 0 ? C.surface : C.bg }}>
              {headers.map((h, j) => (
                <td
                  key={j}
                  style={{
                    padding: "5px 8px",
                    textAlign: h.align || "left",
                    fontFamily: h.mono ? mono : font,
                    fontWeight: h.bold ? 600 : 400,
                    color: C.text,
                    whiteSpace: "nowrap",
                    maxWidth: h.maxW || "auto",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {h.render ? h.render(row, i) : row[h.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>

        {/* Ligne totaux */}
        {rows.length > 0 && (
          <tfoot>
            <tr style={{ background: C.bg }}>
              {headers.map((h, j) => (
                <td
                  key={j}
                  style={{
                    padding: "6px 8px",
                    textAlign: h.align || "left",
                    fontFamily: mono,
                    fontWeight: 700,
                    fontSize: 11,
                    borderTop: `1.5px solid ${C.border}`,
                  }}
                >
                  {h.total ? h.total(rows) : ""}
                </td>
              ))}
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
